import React from 'react';
import { getLabel } from '../../../../data/labels';
import { getConfiguration } from '../../../utils/configuration';
import { getCurrencyValue } from '../../../utils/getCurrencyValue';
import { getPrintableAmount } from '../../../utils/getPrintableAmount';


function DetailedBalanceFooter(props){
	const footer = props.footer;
	const conf = getConfiguration();
	function SummaryProtocol(props){
		const protocolObject = props.protocolObject;
		const title = props.title;
		let showVoidedTicketsOperations = true;
		if(props.protocol === 'PSV'){
			showVoidedTicketsOperations = conf.rs.psvt !== 'golden-race';
		}
		let labelTot = 'Tot ' + props.protocol;
		switch(props.protocol.toUpperCase()){
			case 'PSQF':
                labelTot = getLabel('retail.shop_detailed_balance.cash_availability_sport');
                break;
			case 'PSV':
                labelTot = getLabel('retail.shop_detailed_balance.cash_availability_virtual');
                break;
			case 'CASSA':
                labelTot = getLabel('retail.shop_detailed_balance.cash_availability_cash_movs');
                break;
            default:
                break;
		}
		const otherBettings = props.protocol.toUpperCase() === 'PSIP' || 
							  props.protocol.toUpperCase() === 'PSR' || 
							  props.protocol.toUpperCase() === 'PSCP' || 
							  props.protocol.toUpperCase() === 'PCP';
		if(props.protocol.toUpperCase() === 'PSQF' || props.protocol.toUpperCase() === 'PSV' || otherBettings) {
			return <div className="footerBox">
				<div className={"headerRow"}> 
					<div className={"headerRowChild protocolName"}> {title} </div>
				</div>
				<div className={"bodyRow"}>
					<div className={"bodyRowChild operationDesc"}> { "- " + getLabel('retail.shop_detailed_balance.sold_tickets')} </div>
					<div className={"bodyRowChild operationNumber"}> {getLabel('retail.shop_detailed_balance.op_num') + ' ' + protocolObject.venduto_num} </div>
					<div className={"bodyRowChild operationAmount"}> {getLabel('retail.shop_detailed_balance.tot') + ' ' + getPrintableAmount(protocolObject.venduto_imp, conf.cs.m, conf.cs.nd)} </div>
				</div>
				{
					showVoidedTicketsOperations &&
					<div className={"bodyRow"}>
						<div className={"bodyRowChild operationDesc"}> { "- " + getLabel('retail.shop_detailed_balance.voided_tickets')} </div>
						<div className={"bodyRowChild operationNumber"}> {getLabel('retail.shop_detailed_balance.op_num') + ' ' + protocolObject.annullato_num} </div>
						<div className={"bodyRowChild operationAmount"}> {getLabel('retail.shop_detailed_balance.tot') + ' ' + getPrintableAmount(protocolObject.annullato_imp, conf.cs.m, conf.cs.nd)} </div>
					</div>
				}
	
				<div className={"bodyRow"}>
					<div className={"bodyRowChild operationDesc"}> { "- " + getLabel('retail.shop_detailed_balance.paid_tickets')} </div>
					<div className={"bodyRowChild operationNumber"}> {getLabel('retail.shop_detailed_balance.op_num') + ' ' + protocolObject.pagato_num} </div>
					<div className={"bodyRowChild operationAmount"}> {getLabel('retail.shop_detailed_balance.tot') + ' ' + getPrintableAmount(protocolObject.pagato_imp, conf.cs.m, conf.cs.nd)} </div>
				</div>
				{ showVoidedTicketsOperations &&
					<div className={"bodyRow"}>
						<div className={"bodyRowChild operationDesc"}> { "- " + getLabel('retail.shop_detailed_balance.rembursed_tickets')} </div>
						<div className={"bodyRowChild operationNumber"}> {getLabel('retail.shop_detailed_balance.op_num') + ' ' + protocolObject.rimborsato_num} </div>
						<div className={"bodyRowChild operationAmount"}> {getLabel('retail.shop_detailed_balance.tot') + ' ' + getPrintableAmount(protocolObject.rimborsato_imp, conf.cs.m, conf.cs.nd)} </div>
					</div>
				}
	
				<div className="operationMonospace cashAvailability">
			 		{labelTot} : 
			 		{getCurrencyValue(protocolObject.totalePerProdotto, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
				</div>	
			</div>		
		}
		return <div className="footerBox">
			<div className={"headerRow"}> 
				<div className={"headerRowChild protocolName"}> {title} </div>
			</div>
			<div className={"bodyRow"}>
				<div className={"bodyRowChild operationDesc"}> { "- " + getLabel('retail.shop_detailed_balance.grant_cash_op')} </div>
				<div className={"bodyRowChild operationNumber"}> {getLabel('retail.shop_detailed_balance.op_num') + ' ' + protocolObject.sovvenzione_num} </div>
				<div className={"bodyRowChild operationAmount"}> {getLabel('retail.shop_detailed_balance.tot') + ' ' + getPrintableAmount(protocolObject.sovvenzione_imp, conf.cs.m, conf.cs.nd)} </div>
			</div>
			

			<div className={"bodyRow"}>
				<div className={"bodyRowChild operationDesc"}> { "- " + getLabel('retail.shop_detailed_balance.returning_cash_op')} </div>
				<div className={"bodyRowChild operationNumber"}> {getLabel('retail.shop_detailed_balance.op_num') + ' ' + protocolObject.restituzione_num} </div>
				<div className={"bodyRowChild operationAmount"}> {getLabel('retail.shop_detailed_balance.tot') + ' ' + getPrintableAmount(protocolObject.restituzione_imp, conf.cs.m, conf.cs.nd)} </div>
			</div>
			

			<div className={"bodyRow"}>
				<div className={"bodyRowChild operationDesc"}> { "- " + getLabel('retail.shop_detailed_balance.emitted_vouchers')} </div>
				<div className={"bodyRowChild operationNumber"}> {getLabel('retail.shop_detailed_balance.op_num') + ' ' + protocolObject.voucher_emessi_num} </div>
				<div className={"bodyRowChild operationAmount"}> {getLabel('retail.shop_detailed_balance.tot') + ' ' + getPrintableAmount(protocolObject.voucher_emessi_imp, conf.cs.m, conf.cs.nd)} </div>
			</div>


			<div className={"bodyRow"}>
				<div className={"bodyRowChild operationDesc"}> { "- " + getLabel('retail.shop_detailed_balance.paid_vouchers')} </div>
				<div className={"bodyRowChild operationNumber"}> {getLabel('retail.shop_detailed_balance.op_num') + ' ' + protocolObject.voucher_pagati_num} </div>
				<div className={"bodyRowChild operationAmount"}> {getLabel('retail.shop_detailed_balance.tot') + ' ' + getPrintableAmount(protocolObject.voucher_pagati_imp, conf.cs.m, conf.cs.nd)} </div>
			</div>
			
			
			<div className={"bodyRow"}>
				<div className={"bodyRowChild operationDesc"}> { "- " + getLabel('retail.shop_detailed_balance.used_vouchers')} </div>
				<div className={"bodyRowChild operationNumber"}> {getLabel('retail.shop_detailed_balance.op_num') + ' ' + protocolObject.voucher_inseriti_num} </div>
				<div className={"bodyRowChild operationAmount"}> {getLabel('retail.shop_detailed_balance.tot') + ' ' + getPrintableAmount(protocolObject.voucher_inseriti_imp, conf.cs.m, conf.cs.nd)} </div>
			</div>

			<div className={"bodyRow"}>
				<div className={"bodyRowChild operationDesc"}> { "- " + getLabel('retail.shop_detailed_balance.rest_vouchers')} </div>
				<div className={"bodyRowChild operationNumber"}> {getLabel('retail.shop_detailed_balance.op_num') + ' ' + protocolObject.voucher_resto_num} </div>
				<div className={"bodyRowChild operationAmount"}> {getLabel('retail.shop_detailed_balance.tot') + ' ' + getPrintableAmount(protocolObject.voucher_resto_imp, conf.cs.m, conf.cs.nd)} </div>
			</div>
		

			<div className="operationMonospace cashAvailability">
		 		{labelTot} : 
		 		{getCurrencyValue(protocolObject.totalePerProdotto, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
			</div>	
		</div>	

	}
	
	return <>
		{ props.showSummaryLabel && <div className="operationMonospace summary">{getLabel('retail.shop_detailed_balance.summary')}</div> }
		
		{
			Object.keys(footer).map((key)=> {
				let protocolDescription = key;
				if(typeof footer[key] === 'object'){
					switch(key.toUpperCase()){
						case 'PSQF':
                            protocolDescription = getLabel('retail.protocol.psqf_desc');
                            break;
						case 'PSV':
                            protocolDescription = getLabel('retail.protocol.psv_desc');
                            break;
						case 'CASSA':
                            protocolDescription = getLabel('retail.shop_detailed_balance.cash_movs');
                            break;
                        default:
                            break;
					}
					return <SummaryProtocol key={key} protocolObject={footer[key]} title={protocolDescription} protocol={key} /> 
				}
				return null;
			})
		}
		<div className="operationMonospace totalCashAvailability"> 
			{getLabel('retail.shop_detailed_balance.current_cash_availability')}: 
			{getCurrencyValue(footer.total != null? footer.total : 0, conf.cs.m, conf.cs.nd, conf.cs.ct)}
			
		</div>
	</>
}
export default DetailedBalanceFooter;